<template>
  <div>
    <div class="checkin__last-call checkin__last-call--expired mt-4 d-block d-md-flex align-items-center justify-content-between" v-if="hdExpired">
      <div class="mb-2 mb-md-0">
        <span style="font-size: 18px" class="mr-1">&#127881;</span> {{ messageExpired }}
      </div>
    </div>
    <div class="checkin__last-call mt-4 d-block d-md-flex align-items-center justify-content-between" v-else>
      <div class="mb-2 mb-md-0">
        <Icon name="infoCircle" width="20" class="mr-2"/>
        {{ message }}
      </div>
      <div class="text-right">
        <b-button size="sm" class="text-nowrap" variant="outline" @click="$bvModal.show('modal-last-chance-hd')">
          {{ $t('pages.checkins.last_call_btn2') }}
        </b-button>
      </div>
    </div>
    <ModalLastChanceHD :date="hdAvailableToFormattedForModal" />
  </div>
</template>


<script>
import ModalLastChanceHD from "@/domain/checkin/ModalLastChanceHD.vue";

export default {
  name: "InfoHdAvailable",
  components: {ModalLastChanceHD},
  props: {
    hdAvailableFrom: {
      type: String,
      required: false
    },
    hdAvailableTo: {
      type: String,
      required: true
    }
  },
  computed: {
    hdAvailableFromFormatted() {
      return this.$options.filters.formatDate(this.hdAvailableFrom)
    },
    hdAvailableToFormatted() {
      return this.$options.filters.formatDate(this.hdAvailableTo)
    },
    hdAvailableToFormattedForModal() {
      return this.$options.filters.formatDate(this.hdAvailableTo, 'dddd L')
    },
    hdExpired() {
      return new Date(this.hdAvailableTo) < new Date()
    },
    message() {
      return this.$t('pages.checkins.last_call_message', {date: this.hdAvailableToFormatted})
    },
    messageExpired() {
      return this.$t('pages.checkins.last_call_message_expired', {date: this.hdAvailableToFormatted})
    }

  },
}
</script>

<style scoped>

</style>